// src/Pages/TeamPage.js
import React from 'react';
import Team  from '../Components/Team';

const TeamPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-pink-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-2xl p-8 md:p-12 text-center border border-gray-100">
        <h2 className="text-4xl font-extrabold text-gray-900 mb-10 drop-shadow-sm">Meet Our Exceptional Team</h2>
        <p className="text-xl text-gray-700 mb-12 max-w-3xl mx-auto">
          Our strength lies in our diverse, highly skilled, and globally distributed team. We are a collective of passionate technocrats committed to delivering excellence.
        </p>

        <div>
          <Team />
          {/* Team Member Card 1 
          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-blue-500 group">
            <img
              src="[https://placehold.co/150x150/60A5FA/FFFFFF?text=Dev+Lead](https://placehold.co/150x150/60A5FA/FFFFFF?text=Dev+Lead)"
              alt="Team Member"
              className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-blue-200 group-hover:border-blue-400 transition-colors duration-300"
              onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/60A5FA/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/60A5FA/FFFFFF?text=Image+Unavailable)'; }}
            />
            <h3 className="text-2xl font-bold text-blue-800 mb-2 group-hover:text-blue-900 transition-colors duration-300">John Doe</h3>
            <p className="text-blue-600 font-semibold mb-3">Lead Software Engineer (USA)</p>
            <p className="text-gray-700 text-sm">
              An expert in scalable web architectures and cloud solutions, bringing years of experience to complex projects.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-green-500 group">
            <img
              src="[https://placehold.co/150x150/34D399/FFFFFF?text=UX+Designer](https://placehold.co/150x150/34D399/FFFFFF?text=UX+Designer)"
              alt="Team Member"
              className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-green-200 group-hover:border-green-400 transition-colors duration-300"
              onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/34D399/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/34D399/FFFFFF?text=Image+Unavailable)'; }}
            />
            <h3 className="text-2xl font-bold text-green-800 mb-2 group-hover:text-green-900 transition-colors duration-300">Jane Smith</h3>
            <p className="text-green-600 font-semibold mb-3">Senior UX/UI Designer (UK)</p>
            <p className="text-gray-700 text-sm">
              Passionate about creating intuitive and visually appealing user experiences that delight clients and users.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-red-500 group">
            <img
              src="[https://placehold.co/150x150/F87171/FFFFFF?text=Mobile+Dev](https://placehold.co/150x150/F87171/FFFFFF?text=Mobile+Dev)"
              alt="Team Member"
              className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-red-200 group-hover:border-red-400 transition-colors duration-300"
              onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/F87171/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/F87171/FFFFFF?text=Image+Unavailable)'; }}
            />
            <h3 className="text-2xl font-bold text-red-800 mb-2 group-hover:text-red-900 transition-colors duration-300">Alex Johnson</h3>
            <p className="text-red-600 font-semibold mb-3">Mobile App Developer (Canada)</p>
            <p className="text-gray-700 text-sm">
              Specializing in cross-platform mobile development, building high-performance apps for iOS and Android.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-yellow-500 group">
            <img
              src="[https://placehold.co/150x150/FACC15/FFFFFF?text=QA+Eng](https://placehold.co/150x150/FACC15/FFFFFF?text=QA+Eng)"
              alt="Team Member"
              className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-yellow-200 group-hover:border-yellow-400 transition-colors duration-300"
              onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/FACC15/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/FACC15/FFFFFF?text=Image+Unavailable)'; }}
            />
            <h3 className="text-2xl font-bold text-yellow-800 mb-2 group-hover:text-yellow-900 transition-colors duration-300">Priya Sharma</h3>
            <p className="text-yellow-600 font-semibold mb-3">QA Lead (India)</p>
            <p className="text-gray-700 text-sm">
              Ensuring the highest quality standards through rigorous testing and quality assurance processes.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-indigo-500 group">
            <img
              src="[https://placehold.co/150x150/818CF8/FFFFFF?text=Project+Mgr](https://placehold.co/150x150/818CF8/FFFFFF?text=Project+Mgr)"
              alt="Team Member"
              className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-indigo-200 group-hover:border-indigo-400 transition-colors duration-300"
              onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/818CF8/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/818CF8/FFFFFF?text=Image+Unavailable)'; }}
            />
            <h3 className="text-2xl font-bold text-indigo-800 mb-2 group-hover:text-indigo-900 transition-colors duration-300">David Lee</h3>
            <p className="text-indigo-600 font-semibold mb-3">Project Manager (USA)</p>
            <p className="text-gray-700 text-sm">
              A seasoned project manager ensuring smooth execution and timely delivery of all client projects.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-b-4 border-teal-500 group">
            <img
              src="[https://placehold.co/150x150/5EEAD4/FFFFFF?text=Data+Eng](https://placehold.co/150x150/5EEAD4/FFFFFF?text=Data+Eng)"
              alt="Team Member"
              className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-teal-200 group-hover:border-teal-400 transition-colors duration-300"
              onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/150x150/5EEAD4/FFFFFF?text=Image+Unavailable](https://placehold.co/150x150/5EEAD4/FFFFFF?text=Image+Unavailable)'; }}
            />
            <h3 className="text-2xl font-bold text-teal-800 mb-2 group-hover:text-teal-900 transition-colors duration-300">Sarah Chen</h3>
            <p className="text-teal-600 font-semibold mb-3">Data Engineer (India)</p>
            <p className="text-gray-700 text-sm">
              Specializing in data pipelines, analytics, and ensuring data integrity for informed decision-making.
            </p>
          </div>
          */}
        </div>
        <div className="mt-12 text-lg text-gray-800">
          Our global team collaborates seamlessly to bring your vision to life with unparalleled technical excellence and dedication.
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
// import { Team } from "../components/Team";

// // pages/Team.js
// const TeamPage = () => (
//   <div className="container-fluid">
//     <Team />
//   </div>
// );

// export default TeamPage;